import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';
import { IPromotion } from '../models/promotion.model';

@Injectable({
  providedIn: 'root'
})

export class PromotionService {

  constructor(private http: HttpClient) {}

  //api/post-promotion/all-seller-backoffice?fields=post,promotion
  getKahpooSellerPromotions(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/post-promotion/all-seller-backoffice?fields=post,promotion&page=${page}&size=${size}`);
  }

  allKahpooPostsPromotions(page: number, size: number, minPrice: number, maxPrice: number, isFilterByProductAndService: boolean, isFilterByService: boolean, isFilterByProduct: boolean, isCheckedAnnoncePromotion: boolean, isCheckedAnnonceVedette: boolean, searchText: any): Observable<any>{
    return this.http.get(`${environment.url}/v1/kahpoo/posts/allkahoopost?fields=postServiceModels,postPromotions,postSubProducts&postSearchText=${searchText}&page=${page}&size=${size}&minPrice=${minPrice}&maxPrice=${maxPrice}&isFilterByProductAndService=${isFilterByProductAndService}&isFilterByService=${isFilterByService}&isFilterByProduct=${isFilterByProduct}&isCheckedAnnoncePromotion=${isCheckedAnnoncePromotion}&isCheckedAnnonceVedette=${isCheckedAnnonceVedette}`);
  }

//('/_search?search=name:' + search + '&page=' + page + '&size=' + size)
  getKahpooSellerPromotionsFilter(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/post-promotion/all-seller-backoffice?fields=post,promotion&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  // api/promotion/all/kahpoo
  getKahpooPromotions(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/promotion/all/kahpoo`, {'headers': headers});
  }

  getPromotions(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/promotion`, {'headers': headers});
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/promotion` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  //Liste des promotions du vendeur
  getSellerPostPromotions(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/post-promotion/all-by-user?fields=post,promotion`, {'headers': headers});
  }

  getPromotionBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/promotion` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  savePromotion(promotion: IPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/promotion`, promotion, {'headers': headers});
  }

  getIdPromotion(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/promotion/` + id, {'headers': headers});
  }

  updatePromotion(promotion: IPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/promotion/` + promotion.id, promotion, {'headers': headers});
  }

  deletePromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/promotion/` + id, {'headers': headers});
  }


  updatePromotionVisibility(promo: IPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/promotion/update-type-kahpoo-promotion/` + promo.id, promo, {'headers': headers});
  }
}
